import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/globals';
import { AdmService } from 'src/app/service/adm.service';
import { SystemService } from 'src/app/service/system.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-evaluate',
  templateUrl: './evaluate.component.html',
  styleUrls: ['./evaluate.component.scss']
})
export class EvaluateComponent implements OnInit {

  showLoader: boolean = false;
  creating: boolean = false;
  // candidateID = 1;
  // candidateData: any;

  url: string = "";
  imageUrl: any = "https://gravatar.com/avatar/ae4e3e608c9496ff0a04d46b0304cbe8?s=400&d=robohash&r=x";
  uploadImage: any;
  countries: any;
  regions: any;
  provinces: any;
  city: any;
  maritalStatus: any;
  milStatus: any;
  appstatusEvaluation: any;
  candId: any;
  candNameEn: any;
  candNameAr: any;
  candNatId: any;
  candCode: any;
  currentDate = new Date();
  photoPath: any = "assets/images/stud-image.png";

  evaluateForm = new FormGroup({
    candCode: new FormControl(''),
    evaluateDate: new FormControl(new Date().toLocaleDateString(), [
      // Validators.required,
    ]),
    evaluateStatus: new FormControl('', [
      // Validators.required,
    ]),
    evaluateComment: new FormControl('', [
      Validators.required,
    ]),
  });
  constructor(private admService: AdmService
    // , private roleService: RoleService
    , public globals: Globals, private toastr: ToastrService,
    public activatedRoute: ActivatedRoute, public router: Router,
    private systemService: SystemService,
    public translate: TranslateService) { }

  ngOnInit(): void {
    this.activatedRoute
      .queryParams
      .subscribe(params => {
        this.candId = params['candId'] || "";

        if (this.candId != "") {
          this.getCandById(this.candId);
        } else {

          this.toastr.warning(this.translate.instant('NOT_FOUND'));
          this.router.navigate(['/admission/candidate-inquiry']);
        }
      });
  }
  getCandById(candId: number) {
    this.admService.getCandidateById(candId).subscribe(
      data => {
        this.evaluateForm.controls.candCode.setValue(data.candCode);
        this.candNameEn = data.fullNameEn;
        this.candNameAr = data.fullNameAr;
        this.candNatId = data.nidNo;
        this.candCode = data.candCode;
        this.photoPath = `${environment.API_URL_UTIL}/api/downloadFile/${data.photoFilename}`;
        ///////////////////
        this.evaluateForm.controls.evaluateComment.setValue(data.acceptanceComment); // acceptanceComment
        this.evaluateForm.controls.evaluateStatus.setValue(data.acceptanceStatus); // acceptanceStatus
        if (data.acceptanceDate != null && data.acceptanceDate !== undefined && data.acceptanceDate.length > 0) {
          let acceptanceDateValue = new Date(data.acceptanceDate)
          this.evaluateForm.controls.evaluateDate.setValue(acceptanceDateValue.toLocaleDateString());//acceptanceDate
        }
      },
      error => {
        this.toastr.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
      }
    );
  }
  evaluateSubmit() {
    if (this.evaluateForm.valid) {
      this.creating = true;

      if (this.evaluateForm.controls.evaluateStatus.value === 'Accepted') {
        this.appstatusEvaluation = 60;
      } else if (this.evaluateForm.controls.evaluateStatus.value === 'Rejected') {
        this.appstatusEvaluation = 70;
      } else {
        this.appstatusEvaluation = 80;
      }
      // this.admService.addEvaluateData(this.candId, this.evaluateForm.controls.evaluateComment.value, this.evaluateForm.controls.evaluateStatus.value, this.currentDate
      //   , this.appstatusEvaluation)
      this.admService.addEvaluateDataAndUsername(this.candId, this.evaluateForm.controls.evaluateComment.value, this.evaluateForm.controls.evaluateStatus.value, this.currentDate
        , this.appstatusEvaluation, this.globals.currentUserInfo.username)
        .subscribe(
          data => {
            this.router.navigate(['/admission/candidate-inquiry']);
            this.toastr.success(this.translate.instant("UPDATED_SUCCESSFULLY"));
          },
          error => {
            this.creating = false
            this.toastr.warning(this.translate.instant("CAN_NOT_UPDATE"));
          },
          () => this.creating = false
        );
    }
    else {
      console.log("non valid");
      this.evaluateForm.markAllAsTouched();
      this.evaluateForm.markAsDirty();
      this.creating = false;
    }
  }

  evaluateChange() {

  }

  // getCandidate() {
  //   this.admService.getCandidateById(this.candId)
  //     .subscribe(
  //       data => {
  //         // evaluateDate: new FormControl('', [
  //         //   Validators.required,
  //         // ]),
  //         // evaluateStatus: new FormControl('', [
  //         //   Validators.required,
  //         // ]),
  //         // evaluateComment: new FormControl('', [
  //         //   Validators.required,
  //         // ]),
  //         // this.evaluateForm.controls.evaluateDate.setValue();
  //         // this.evaluateForm.controls.evaluateStatus.setValue();
  //         // this.evaluateForm.controls.evaluateComment.setValue();
  //         // this.candidateData = data;
  //       },
  //       error => {
  //         this.showLoader = false
  //         this.toastr.success("can't get candidate for Id " + this.candId);
  //       },
  //       () => this.showLoader = false
  //     );
  // }

  changeAcceptanceStatus(acceptanceStatus: string) {
    this.evaluateForm.controls.evaluateStatus.setValue(acceptanceStatus);
  }
}
